import React from "react";
import { Link } from "react-router-dom";
import "./Home.scss";

const Home = () => {
  return (
    <div className="Home">
      <div className="Home-container">
        <Link className="Home-container_iphone" to={"/iPhone"}>
          <img
            className="Home-container_iphone--img"
            src="home/homeIphone.png"
          />
          <h2 className="Home-container_iphone--txt">Iphone</h2>
        </Link>
        <Link className="Home-container_mac" to={"/Mac"}>
          <img className="Home-container_mac--img" src="home/homeMac.png" />
          <h2 className="Home-container_mac--txt">Mac</h2>
        </Link>
        <Link className="Home-container_accessories" to={"/Accesories"}>
          <img
            className="Home-container_accessories--img"
            src="home/homeAccessories.png"
          />
          <h2 className="Home-container_accessories--txt">Accesorios</h2>
        </Link>
      </div>
    </div>
  );
};

export default Home;
